// extracted by mini-css-extract-plugin
module.exports = {"app":"styles_app__c-xFM","mainPageWrapper":"styles_mainPageWrapper__2SMmW","mainPageFull":"styles_mainPageFull__2MK1B","mainPage":"styles_mainPage__1RrVn"};